<template lang="pug">
div
    .text-center
        img(v-bind:src="logo" width="80px")

        .col-sm-12.text-center.p-t-1
            small.block(v-if="outlet.company_details") {{ outlet.company_details.name }}
            small.block {{ outlet.name }}
            small.block(v-html="formattedAddress")
            small.block {{ receiptDateFormatModal(pgsql_transaction.receipt_date, null) }}
            small.block(v-if="outlet.phone_no") {{ trans('receipt.phone') }}: {{ outlet.phone_no }}
            small.block {{ trans('receipt.site') }}: {{ outlet.code }}
            small.block(v-if="stan") {{ trans('receipt.stan') }}: {{ stan }}
            small.block(v-if="approvalCode") {{ trans('receipt.approval_code') }}: {{ approvalCode }}
            small.block(v-if="referenceNo") {{ trans('receipt.reference_number') }}: {{ referenceNo }}
            small.block(v-if="ghlPaymentReferenceNo") {{ trans('receipt.payment_reference_number') }}: {{ ghlPaymentReferenceNo }}
            small.block(v-if="ghlRefundReferenceNo") {{ trans('receipt.refund_reference_number') }}: {{ ghlRefundReferenceNo }}
            small.block(v-if="ghlMerchantId") {{ trans('receipt.mid') }}: {{ ghlMerchantId }}
            small.block(v-if="ghlTerminalId") {{ trans('receipt.tid') }}: {{ ghlTerminalId }}

    .row
        .col-sm-12
            hr

        .col-sm-12(v-if="!cancelledItemContext")
            small.dark.block.text-center.m-y-sm {{ receiptTypeTitle }}

    .row(v-if="!pgsql_transaction.drawer_session && !pgsql_transaction.forecourt_attendant")
        .col-sm-12
            .row
                .col-xs-4
                    small.pull-left {{ trans('receipt.invoice_number') }}
                    br
                    h5.pull-left {{ receiptNumberFormat(receipt) }}

            .row(v-if="shouldShowOriginalInvoice")
                .col-xs-4
                .col-xs-4
                .col-xs-4
                    small.pull-left {{ trans('receipt.original_invoice_number') }}
                    br
                    h5.pull-left {{ receiptNumberFormat(receipt.original_receipt) }}

    .row(v-else-if="pgsql_transaction.forecourt_attendant && pgsql_transaction.forecourt_attendant.id")
        .col-sm-12

            .row
                .col-xs-4
                    small.pull-left {{ trans('receipt.invoice_number') }}
                    br
                    h5.pull-left {{ receiptNumberFormat(receipt) }}

            .row(v-if="shouldShowOriginalInvoice")
                .col-xs-4
                .col-xs-4
                .col-xs-4
                    small.pull-left {{ trans('receipt.original_invoice_number') }}
                    br
                    h5.pull-left {{ receiptNumberFormat(receipt.original_receipt) }}

        .col-sm-12
            hr

            .row
                .col-xs-4
                    small.pull-left {{ trans('receipt.attendant') }}
                    br
                    h5.pull-left {{ pgsql_transaction.forecourt_attendant.staff_name }}

                .col-xs-4
                    small.pull-left {{ trans('receipt.attendant_card_number') }}
                    br
                    h5.pull-left {{ pgsql_transaction.forecourt_attendant.card_pan }}

                .col-xs-4
                    small.pull-left {{ trans('receipt.attendant_till_number') }}
                    br
                    h5.pull-left {{ pgsql_transaction.forecourt_attendant.sequence_number }}

        .col-sm-12
            hr

    .row(v-else)

        .col-sm-12
            .row
                .col-xs-4.text-break
                    small.pull-left {{ trans('receipt.pos') }}
                    br
                    h5.pull-left {{ pgsql_transaction.drawer_session.device_name }}

                .col-xs-4
                    small.pull-left {{ trans('receipt.staff') }}
                    br
                    h5.pull-left {{ pgsql_transaction.drawer_session.staff_name }}

                .col-xs-4
                    small.pull-left {{ trans('receipt.invoice_number') }}
                    br
                    h5.pull-left {{ receiptNumberFormat(receipt) }}

            .row
                .col-xs-4
                    small.pull-left {{ trans('receipt.shift_number') }}
                    br
                    h5.pull-left {{ pgsql_transaction.drawer_session.sequence_number }}
                .col-xs-4(v-if="shouldShowOriginalInvoice")
                .col-xs-4(v-if="shouldShowOriginalInvoice")
                    small.pull-left {{ trans('receipt.original_invoice_number') }}
                    br
                    h5.pull-left {{ receiptNumberFormat(receipt.original_receipt) }}
        .col-sm-12
            hr
</template>

<script>
import receiptMixin from '../../mixins/receipt';
import { mapGetters } from 'vuex';
import Auth from '@js/plugins/auth';

export default {
    mixins: [receiptMixin],

    computed: {
        ...mapGetters('transactionPostgres', [
            'pgsql_transaction',
            'outlet',
            'receipt',
            'approvalCode',
            'referenceNo',
            'stan',
            'ghlPaymentReferenceNo',
            'ghlRefundReferenceNo',
            'ghlMerchantId',
            'ghlTerminalId',
            'receiptType',
            'cancelledItemContext',
        ]),

        ...mapGetters('transaction', ['transaction']),

        logo() {
            return Auth.franchise().logo;
        },

        formattedAddress() {
            const escaped = (this.outlet.address || '')
                .replace(/&/g, '&amp;')
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;');
            return escaped.replace(/\n/g, '<br>');
        },

        receiptTypeTitle() {
            const type = this.receiptType;

            switch (type) {
                case 'VOID':
                    return `${this.trans(
                        'receipt.receipt_type_void',
                    )}: ${this.receiptDateFormat(
                        this.pgsql_transaction.receipt_date,
                    )}`;
                case 'REFUND':
                    return this.trans('receipt.receipt_type_return_item');
                default:
                    if (this.isShellCardReceipt(this.pgsql_transaction)) {
                        return this.trans('receipt.receipt_type_shell_card');
                    }

                    return this.trans('receipt.receipt_type_tax_invoice');
            }
        },
    },

    methods: {
        isShellCardReceipt(transaction) {
            const shellCardTypes = [
                'shell_card',
                'manual_shell_card',
                'smartpay_b2b',
            ];

            if (transaction && Array.isArray(transaction.payments)) {
                return transaction.payments.some(
                    payment =>
                        payment &&
                        payment.card &&
                        payment.card.type &&
                        shellCardTypes.includes(payment.card.type),
                );
            }

            return false;
        },
    },
};
</script>
